/**=========================================================
 * Module: form.js
 * Form Controller
 =========================================================*/

App.controller('FormController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R) {
    "use strict";
    
    $scope.defaults = {
        cls: 'form-horizontal'
    };
    
    
    $scope.toggle = function(field){
    	for(var i=0; i<$scope.form.fields.length; i++){
    		if(field.toggle==$scope.form.fields[i].name){
                $scope.form.fields[i].available = !$scope.form.fields[i].available;
                
    		}
    	}
    };

    function isElementInViewport (el) {

        //special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        if(el){
            var rect = el.getBoundingClientRect();
        
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            );
        } else {
            return true;
        }
    }

    $scope.scroll = function(event){

        if(!isElementInViewport($('input[type=submit]', event.currentTarget))){
      
            $('html, body').animate({
                scrollTop: $('input[type=submit]', event.currentTarget).offset().top
            }, 1000);
        }
      
    }
      
  }
  ]);